module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAAAj0lEQVR4AWOgCzhw72vO5udZmwgjqIb///9fffmjcNsLojWAweOPvyp2viROAwy8/fan5cBrYjQgwI/f/6aceEechr4+CP333/+Vlz8S1IAAX35/zThdIbRWGxNh0XDq7QXDHW5AOcIa/vz723Vtmug6XaAEYQ0PvjzxOhALESWsYd3j7QqbzIF8whoGJQAA7fYhBjZ+xVEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/DJ.png
// module id = 1123
// module chunks = 0